import axios from '../api/axios';
import useAuth from './useAuth';

const useRefreshToken = () => {
    const { setAuth } = useAuth();

    const refresh = async () => {
        const response = await axios.get('/auth/refresh', {
            withCredentials: true
        });
        setAuth(prev => {
            console.log(JSON.stringify(prev));
            console.log(response.data.accessToken);
            return {
                ...prev,
                accessToken: response.data.accessToken,
                id: response.data.id,
                username: response.data.username,
                firstname: response.data.firstname,
                lastname: response.data.lastname,
                company: response.data.company,
                companyId: response.data.companyId,
                role: response.data.role
            }
        });
        return response.data.accessToken;
    }
    return refresh;
};

export default useRefreshToken;